import script from "./activateBrand.vue?vue&type=script&setup=true&lang=js"
export * from "./activateBrand.vue?vue&type=script&setup=true&lang=js"

import "./activateBrand.vue?vue&type=style&index=0&id=8a26e788&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a26e788"]])

export default __exports__